module.exports = __webpack_public_path__ + "static/design-concepts-293ee04f5704034badb88b927db620c3.png";